import React, { Component } from "react";
import { SwitchWrapper } from "./ToggleSwitch.style";

/**
 * @component
 * @example
 * // Example usage:
 * <ToggleSwitch
 *  htmlFor="toggleSwitch"
 *  isChecked={isChecked}
 *  onClick={handleClick}
 *  name="toggleSwitch"
 *  onChange={handleChange}
 * />
 *
 * @param {string} htmlFor
 * @param {boolean} isChecked
 * @param {function} onClick
 * @param {string} name
 * @param {function} onChange
 *
 */
class ToggleSwitch extends Component {
  render() {
    const { htmlFor, isChecked, onClick, name, onChange, disabled } = this.props;

    return (
      <SwitchWrapper
        disabled={disabled}
        onMouseDown={(event) => {
          event.stopPropagation(); 
        }}
        onMouseUp={(event) => {
          event.stopPropagation(); 
        }}
      >
        <input
          disabled={disabled}
          type="checkbox"
          id={htmlFor}
          name={name}
          checked={isChecked}
          onChange={(e) => onChange && onChange(e)}
          // onClick={(e) => onClick && onClick(e)}
        />
        <label htmlFor={htmlFor} className="switch_label"
          onClick={(e) => onClick && onClick(e)}
        >
          <span className="onf_btn"></span>
        </label>
      </SwitchWrapper>
    );
  }
}

export default ToggleSwitch;
